'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = require('ifeis-isomorphic/lib/redux/actions/events');

var _person = require('ifeis-isomorphic/lib/redux/actions/person');

var _registrations = require('ifeis-isomorphic/lib/redux/actions/registrations');

var _scores = require('ifeis-isomorphic/lib/redux/actions/scores');

var _getScoresheet = require('ifeis-isomorphic/lib/redux/actions/scores/getScoresheet');

var _getScoresheet2 = _interopRequireDefault(_getScoresheet);

var _comments = require('ifeis-isomorphic/lib/redux/actions/comments');

var _getFeisAge = require('ifeis-isomorphic/lib/utilities/getFeisAge');

var _getFeisAge2 = _interopRequireDefault(_getFeisAge);

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _mapStateToController = require('./mapStateToController');

var _mapStateToController2 = _interopRequireDefault(_mapStateToController);

var _focus = require('../../../../../../focus');

var _focus2 = _interopRequireDefault(_focus);

var _enterableElements = require('../../../../../../enterable-elements');

var _enterableElements2 = _interopRequireDefault(_enterableElements);

var _adjudicators = require('../../../../../../adjudicators');

var _adjudicators2 = _interopRequireDefault(_adjudicators);

var _registrations2 = require('../../../../../../registrations');

var _registrations3 = _interopRequireDefault(_registrations2);

var _events2 = require('../../../../../../events');

var _events3 = _interopRequireDefault(_events2);

var _eventPipeline = require('../eventPipeline');

var _eventPipeline2 = _interopRequireDefault(_eventPipeline);

var _immutable = require('immutable');

var _ifeisIsomorphic = require('ifeis-isomorphic');

var _getDressChecks = require('ifeis-isomorphic/lib/redux/actions/dress-checks/getDressChecks');

var _getDressChecks2 = _interopRequireDefault(_getDressChecks);

var _createDressCheck = require('ifeis-isomorphic/lib/redux/actions/dress-checks/createDressCheck');

var _createDressCheck2 = _interopRequireDefault(_createDressCheck);

var _updateDressCheck = require('ifeis-isomorphic/lib/redux/actions/dress-checks/updateDressCheck');

var _updateDressCheck2 = _interopRequireDefault(_updateDressCheck);

var _deleteDressCheck = require('ifeis-isomorphic/lib/redux/actions/dress-checks/deleteDressCheck');

var _deleteDressCheck2 = _interopRequireDefault(_deleteDressCheck);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var genArray = function genArray(n) {
  return Array.apply(null, { length: n }).map(Number.call, Number);
};

var TabulationsScoresheetController = function () {
  function TabulationsScoresheetController($q, $scope, $state, $ngRedux, fEventPipelineService, feis, event_id, adjudicator_id, fPrompt, $mdDialog, $mdSidenav, metadata, msgService, ngAudio) {
    var _this = this;

    _classCallCheck(this, TabulationsScoresheetController);

    this._svc = {
      $q: $q,
      $scope: $scope,
      $ngRedux: $ngRedux,
      fEventPipelineService: fEventPipelineService,
      $mdDialog: $mdDialog,
      fPrompt: fPrompt,
      $state: $state,
      $mdSidenav: $mdSidenav,
      msgService: msgService
    };
    this.eventPipeline = fEventPipelineService(feis.id);
    this.feis = feis;
    this.event_id = event_id;
    this.adjudicator_id = adjudicator_id;
    this.roles = metadata.grants;
    this.showComments = false;
    this.showDressCheck = false;
    this.isBulkEditFeatureSet = false;
    this.focusCompetitorInput = false;
    this.newPerson = {};
    this.scoresTemplate;

    this._svc.$ngRedux.dispatch((0, _events.getEvent)(feis.id, event_id)).then(function (event) {
      if (event.payload.rounds) {
        _this.scoresTemplate = genArray(event.payload.rounds);
      } else if (event.payload.type === 'C') {
        _this.scoresTemplate = genArray(3);
      } else {
        _this.scoresTemplate = genArray(1);
      }
      _this.scoresTemplate = _this.scoresTemplate.map(function (n) {
        return n = { round: n + 1 };
      });
      _this.newPerson = {
        scores: [].concat(_this.scoresTemplate).map(function (i) {
          return angular.copy(i);
        }),
        comment: {
          text: ''
        }
      };
    });
    this._svc.$ngRedux.dispatch((0, _events.getAdjudicatorsForEvent)(feis.id, event_id));
    this._svc.$ngRedux.dispatch((0, _events.getParticipants)(feis.id, event_id));
    this._svc.$ngRedux.dispatch((0, _getScoresheet2.default)(feis.id, event_id, adjudicator_id));

    this._svc.$ngRedux.connect(function (state) {
      return (0, _mapStateToController2.default)(feis.id, event_id, adjudicator_id, state);
    })(this);

    // Error sound
    // License: Public Domain | Recorded by KevanGC
    // http://soundbible.com/1598-Electronic-Chime.html
    this.errorSound = ngAudio.load('https://s3.amazonaws.com/cdn.ifeis.net/sounds/error.mp3');
  }

  _createClass(TabulationsScoresheetController, [{
    key: 'checkedIn',
    value: function checkedIn(participant) {
      return participant.get('reg').get('is_checked_in') === 1;
    }
  }, {
    key: 'notCheckedIn',
    value: function notCheckedIn(participant) {
      return participant.get('reg').get('is_checked_in') !== 1;
    }
  }, {
    key: 'error',
    value: function error(msg) {
      this._svc.msgService.displayErrorMsg(msg);
    }
  }, {
    key: 'hasScore',
    value: function hasScore(person) {
      return this.scores.some(function (s) {
        return s.person === person.get('id');
      });
    }
  }, {
    key: 'hasLowScores',
    value: function hasLowScores(person) {
      var q = false;
      angular.forEach(person.scores, function (score) {
        q = q || score.value < 50;
      });
      return q;
    }
  }, {
    key: 'personChange',
    value: function personChange(person) {
      var _this2 = this;

      if (person.$origCompetitor !== person.competitor) {
        var pid;
        this.participants.some(function (p) {
          if (person.competitor === p.competitor) {
            pid = p.id;
            return true;
          }

          return false;
        });

        if (!pid) {
          this.error('Competitor ${person.competitor} not registered for this competition.');
          person.competitor = person.$origCompetitor;
        } else if (this.scores.some(function (s) {
          return s.$origCompetitor === person.competitor;
        })) {
          this.error('You have already entered scores for ' + person.competitor + '.');
          person.competitor = person.$origCompetitor;
        } else {
          // assign new id
          person.person = pid;

          // delete old scores
          return this.deletePerson(person).then(function () {
            person.$origCompetitor = person.competitor;

            // save new scores
            return _this2._svc.$q.all(person.scores.map(function (s) {
              return _this2._svc.$ngRedux.dispatch((0, _scores.createScore)(_this2.feis.id, _this2.event_id, _this2.adjudicator_id, pid, {
                round: s.round,
                value: s.value
              }));
            }));
          }).then(function (scores) {
            _this2._svc.$ngRedux.dispatch((0, _getScoresheet2.default)(feis.id, _this2.event_id, _this2.adjudicator_id));
            return person.comment.text && _this2._svc.$ngRedux.dispatch((0, _comments.createComment)(_this2.feis.id, _this2.event_id, _this2.adjudicator_id, pid, person.comment)) || Promise.resolve();
          }, function (err) {
            return _this2.error(err);
          }).then(function () {
            _this2._svc.msgService.displaySuccessMsg('Competitor number was successfully changed to #' + person.competitor + '.');
          });
        }
      }
    }
  }, {
    key: 'deleteScores',
    value: function deleteScores(person) {
      var _this3 = this;

      return this._svc.$q.all(person.scores.map(function (s) {
        return _this3._svc.$ngRedux.dispatch((0, _scores.deleteScore)(_this3.feis.id, _this3.event_id, s.adjudicator, person.person, s.id));
      }));
    }
  }, {
    key: 'initNewPerson',
    value: function initNewPerson() {
      this.focusCompetitorInput = true;
      this.newPerson = {
        scores: [].concat(this.scoresTemplate).map(function (i) {
          return angular.copy(i);
        })
      };
    }
  }, {
    key: 'deleteComment',
    value: function deleteComment(person) {
      this._svc.$ngRedux.dispatch((0, _getScoresheet2.default)(this.feis.id, this.event_id, this.adjudicator_id));
      if (person.comment && person.comment.id) {
        return this._svc.$ngRedux.dispatch((0, _comments.deleteComment)(this.feis.id, this.event_id, this.adjudicator_id, person.person));
      }
    }
  }, {
    key: 'deletePerson',
    value: function deletePerson(person) {
      var _this4 = this;

      return this.deleteScores(person).then(function () {
        _this4.deleteComment(person);
        return _this4.deleteDressCheck(person);
      });
    }
  }, {
    key: '_validateScore',
    value: function _validateScore(score) {
      return !isNaN(parseFloat(score.value)) && isFinite(score.value);
    }
  }, {
    key: 'addPerson',
    value: function addPerson() {
      var _this5 = this;

      var pid;
      this.participants.some(function (p) {
        if (_this5.newPerson.competitor === p.get('competitor')) {
          pid = p.get('id');
          return true;
        }

        return false;
      });

      if (!pid) {
        this.error('Competitor not registered for this competition.');
        this.errorSound.play();
      } else if (this.scores.some(function (s) {
        return s.competitor === _this5.newPerson.competitor;
      })) {
        this.error('You have already entered scores for ' + this.newPerson.competitor + '.');
        this.errorSound.play();
      } else if (!this.newPerson.scores.every(function (s) {
        return _this5._validateScore(s);
      })) {
        this.error('Scores must be numbers.');
        this.errorSound.play();
      } else if (!this.newPerson.scores.every(function (s) {
        return s.value >= 0 && s.value <= 100;
      })) {
        this.error('Entry is outside normal range, please make sure it\'s correct.');
        this.errorSound.play();
      } else {
        if (this.newPerson.comment && this.newPerson.comment.text) {
          this.newPerson.comment.text = this.newPerson.comment.text.trim();
        }
        var p = angular.copy(this.newPerson);
        p.person = pid;

        this._svc.$q.all(p.scores.map(function (s) {
          return _this5._svc.$ngRedux.dispatch((0, _scores.createScore)(_this5.feis.id, _this5.event_id, _this5.adjudicator_id, p.person, s));
        })).then(function (scores) {
          _this5._svc.$ngRedux.dispatch((0, _getScoresheet2.default)(_this5.feis.id, _this5.event_id, _this5.adjudicator_id));
          _this5._svc.$ngRedux.dispatch((0, _events.getAdjudicatorsForEvent)(_this5.feis.id, _this5.event_id));
          _this5.event.get('status') === 'ADJ' && _this5._svc.$ngRedux.dispatch((0, _events.getEvent)(_this5.feis.id, _this5.event_id));
          p.comment && p.comment.text && p.comment.text != '' && _this5._svc.$ngRedux.dispatch((0, _comments.createComment)(_this5.feis.id, _this5.event_id, _this5.adjudicator_id, pid, p.comment)) || Promise.resolve();
          _this5.showDressCheck && _this5._svc.$ngRedux.dispatch((0, _createDressCheck2.default)(_this5.feis.id, _this5.event_id, _this5.adjudicator_id, p.person, { dressCheck: p.dressCheck })) || Promise.resolve();
          _this5.newPerson = {
            scores: [].concat(_this5.scoresTemplate).map(function (i) {
              return angular.copy(i);
            }),
            comment: {
              text: ''
            }
          };
          _this5.focusCompetitorInput = true;
        }, function (err) {
          return _this5.error(err);
        });
      }
    }
  }, {
    key: 'updateScore',
    value: function updateScore(pid, score) {
      var _this6 = this;

      if (!this._validateScore(score)) {
        this.error('Scores must be numbers.');
        score.value = score.$origScore; // reverting the model value
      } else if (!(score.value >= 0 && score.value <= 100)) {
        this.error('Entry is outside normal range, please make sure it\'s correct.');
        score.value = score.$origScore; // reverting the model value
      } else {
        this._svc.$ngRedux.dispatch((0, _scores.updateScore)(this.feis.id, this.event_id, this.adjudicator_id, pid, score.id, score)).then(function (res) {
          _this6._svc.msgService.displaySuccessMsg('Round ' + score.round + ' score was successfully updated to ' + score.value + '.');
        }, function (err) {
          return _this6.error(err);
        });
      }
    }
  }, {
    key: 'updateComment',
    value: function updateComment(pid, comment) {
      if (!comment) {
        return;
      }
      if (comment.id) {
        return this._svc.$ngRedux.dispatch((0, _comments.updateComment)(this.feis.id, this.event_id, this.adjudicator_id, pid, comment));
      } else {
        return comment.text && this._svc.$ngRedux.dispatch((0, _comments.createComment)(this.feis.id, this.event_id, this.adjudicator_id, pid, comment)) || Promise.resolve();
      }
    }
  }, {
    key: 'registerPerson',
    value: function registerPerson($event) {
      var _this7 = this;

      var person = void 0,
          num = void 0,
          unregister = void 0;

      this._svc.fPrompt({
        action: 'Find',
        type: 'number',
        title: 'Find by Competitor Number',
        label: 'Competitor Number'
      }, $event).then(function (n) {
        num = n;
        if (_this7.participants.some(function (p) {
          return p.get('competitor') === num;
        })) {
          _this7.error('Competitor ' + num + ' is already registered.');
          return _this7._svc.$q.reject();
        } else {
          return _this7._svc.$ngRedux.dispatch((0, _person.getFeisParticipant)(_this7.feis.id, num));
        }
      }).then(function (data) {
        unregister = _this7._svc.$scope.$watch(function () {
          return _this7._svc.$ngRedux.getState();
        }, function () {
          var state = _this7._svc.$ngRedux.getState();
          var participant = state.getIn(['persons', 'one', data.payload.id]);

          if (!participant || participant.size === 0) {
            _this7.error('No competitor with number ' + num + ' exists.');
            unregister();
            return;
          }
          if (participant.get('loading')) {
            return;
          }
          var age = (0, _getFeisAge2.default)(_this7.feis, participant.toJS());
          var dialog = _this7._svc.$mdDialog.confirm().title('Late Add Competitor?').textContent('Register ' + participant.get('fname') + ' ' + participant.get('lname') + ' (' + participant.get('competitor') + '), feis age ' + (age || 'n/a') + ', from ' + participant.getIn(['school', 'name']) + '?').cancel('Cancel').ok('Yes');

          _this7._svc.$mdDialog.show(dialog).then(function () {
            _this7._svc.$ngRedux.dispatch((0, _registrations.createRegistration)(_this7.feis.id, participant.get('id'), { event_id: _this7.event_id }));
          });
          unregister();
        });
      });
    }

    // close this scoresheet and go back to the tabulations page

  }, {
    key: 'closeScoresheet',
    value: function closeScoresheet() {
      this._svc.$state.go('feiseanna.one.admin.tabulations', this.feis);
    }

    // prompt for user to submit scoresheet and close this scoresheet and go back to the tabulations page

  }, {
    key: 'completeScoresheet',
    value: function completeScoresheet() {
      var _this8 = this;

      return this.eventPipeline.completeScoresheet(this.feis.id, this.event_id, this.adjudicator_id).then(function () {
        return _this8._svc.$state.go('feiseanna.one.admin.tabulations', _this8.feis);
      });
    }
  }, {
    key: 'deleteScoresheet',
    value: function deleteScoresheet() {
      var _this9 = this;

      var dialog = this._svc.$mdDialog.confirm().title('Delete scoresheet').textContent('Are you sure you want to delete this scoresheet? This action is irreversible.').cancel('Cancel').ok('Delete');

      this._svc.$mdDialog.show(dialog).then(function () {
        return _this9.scores.map(function (person) {
          _this9._svc.$ngRedux.dispatch((0, _comments.deleteComment)(_this9.feis.id, _this9.event_id, _this9.adjudicator_id, person.person));
          _this9._svc.$ngRedux.dispatch((0, _deleteDressCheck2.default)(_this9.feis.id, _this9.event_id, _this9.adjudicator_id, person.person));
        });
      }).then(function () {
        return _this9._svc.$ngRedux.dispatch((0, _scores.deleteEventScoresByAdjudicator)(_this9.feis.id, _this9.event_id, _this9.adjudicator_id));
      }).then(function () {
        return _this9.closeScoresheet();
      });
    }

    // pull up to date adjudicators for this event, and add them to the event object

  }, {
    key: '_updateEventAdjudicators',
    value: function _updateEventAdjudicators() {
      return this._svc.$ngRedux.dispatch((0, _events.getAdjudicatorsForEvent)(this.feis.id, this.event_id));
    }

    // add a new scoresheet for this event

  }, {
    key: 'addScoresheet',
    value: function addScoresheet() {
      var _this10 = this;

      this._updateEventAdjudicators().then(function () {
        if (_this10.event.get('adjudicators').size > 0 && _this10.event.get('adjudicators').size < _this10.expectedScoresheets) {
          return _this10.eventPipeline.completeScoresheet(_this10.feis.id, _this10.event_id, _this10.adjudicator_id).then(function () {
            return _this10.eventPipeline.addScoresheet(null, _this10.event.toJS());
          });
        } else if (_this10.event.get('adjudicators').size > 0 && _this10.event.get('adjudicators').size === _this10.expectedScoresheets) {
          _this10._svc.$state.go('feiseanna.one.admin.tabulations', _this10.feis);
        } else {
          return _this10.eventPipeline.addScoresheet(null, _this10.event.toJS());
        }
      });
    }
  }, {
    key: 'showPerson',
    value: function showPerson(person) {
      this.currentPerson = person.toJS();
      this._svc.$mdSidenav('participant-sidenav').open();
    }
  }, {
    key: 'toggleShowComments',
    value: function toggleShowComments() {
      var _this11 = this;

      this.showComments = !this.showComments;
      if (this.showComments) {
        this.scores.forEach(function (person) {
          return _this11._svc.$ngRedux.dispatch((0, _comments.getComments)(_this11.feis.id, _this11.event_id, _this11.adjudicator_id, person.person));
        });
      }
    }
  }, {
    key: 'toggleShowDressCheck',
    value: function toggleShowDressCheck() {
      this.showDressCheck = !this.showDressCheck;
      if (this.showDressCheck) {
        this._svc.$ngRedux.dispatch((0, _getDressChecks2.default)(this.feis.id, this.event_id, this.adjudicator_id));
      }
    }
  }, {
    key: 'createDressCheck',
    value: function createDressCheck(dressCheck) {
      this._svc.$ngRedux.dispatch((0, _createDressCheck2.default)(this.feis.id, this.event_id, this.adjudicator_id, this.newPerson.person, { dressCheck: dressCheck }));
    }
  }, {
    key: 'updateDressCheck',
    value: function updateDressCheck(pid) {
      var dressCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      dressCheck.dressCheck = dressCheck.dressCheck === 1 ? 0 : 1;

      if (dressCheck.id) {
        this._svc.$ngRedux.dispatch((0, _updateDressCheck2.default)(this.feis.id, this.event_id, this.adjudicator_id, pid, dressCheck));
      } else {
        this._svc.$ngRedux.dispatch((0, _createDressCheck2.default)(this.feis.id, this.event_id, this.adjudicator_id, pid, dressCheck));
      }
    }
  }, {
    key: 'deleteDressCheck',
    value: function deleteDressCheck(person) {
      this._svc.$ngRedux.dispatch((0, _deleteDressCheck2.default)(this.feis.id, this.event_id, this.adjudicator_id, person.person));
    }
  }, {
    key: 'setBulkEditComments',
    value: function setBulkEditComments() {
      this.isBulkEditFeatureSet = !this.isBulkEditFeatureSet;
    }
  }, {
    key: 'getEventName',
    value: function getEventName() {
      if (this.event) {
        return (0, _ifeisIsomorphic.getDescription)(this.event.toJS());
      }
    }
  }]);

  return TabulationsScoresheetController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.tabulations.scoresheet', ['ui.router', 'ifeis.adjudicators', 'ifeis.focus', 'ifeis.enterable.elements', 'ifeis.registrations', 'ifeis.events', 'ifeis.eventPipeline']).directive('navEnter', function () {
  return {
    restrict: 'A',
    require: 'form',
    controller: function controller($scope, $element, $attrs) {
      var _this12 = this;

      this._inputs = [];

      var getIndex = function getIndex(element, order) {
        var index;

        if (order) {
          _this12._inputs = _this12._inputs.sort(function (a, b) {
            return a.idx - b.idx;
          });
        }

        _this12._inputs.some(function (item, i) {
          if (item.element === element) {
            index = i;
            return true;
          }
        });

        return index;
      };

      this.unregister = function (el) {
        var index = getIndex(el);
        if (index) {
          this._inputs.splice(index, 1);
        }
      };

      this.register = function (element, idx) {
        var index = getIndex(element);

        if (index) {
          this._inputs[index].idx = idx;
        } else {
          this._inputs.push({ element: element, idx: idx });
        }
      };

      this.next = function (element) {
        var index = getIndex(element, true);

        if (index !== undefined && this._inputs.length > index + 1) {
          var el = this._inputs[index + 1].element;

          if (el[0].offsetParent !== null) {
            el.focus();
            return true;
          }
        }

        if ($attrs.navEnter) {
          $scope.$eval($attrs.navEnter);
        }
      };
    }
  };
}).directive('navEnterIdx', function () {
  return {
    restrict: 'A',
    require: '^^navEnter',
    scope: true,
    link: function link(scope, element, attrs, form) {
      attrs.$observe('navEnterIdx', function (idx) {
        if (idx === undefined) {
          return;
        }

        form.register(element, idx);
      });

      element.on('keyup', function (event) {
        if (event.keyCode === 13) {
          if (form.next(element)) {
            event.preventDefault();
            event.stopPropagation();
          }
        }
      });

      scope.$on('$destroy', function () {
        return form.unregister(element);
      });
    }
  };
}).directive('mdKeepLastInView', function ($timeout) {
  return {
    restrict: 'A',
    require: '^mdContent',
    link: function link(scope, element, attrs, mdContent) {
      var oldCount = 0;

      scope.$watch(attrs.mdKeepLastInView, function (count) {
        var els = element.children();
        var lastEl = els[els.length - 1];

        if (count && oldCount < count && lastEl) {
          $timeout(function () {
            return mdContent.$element[0].scrollTop = lastEl.offsetTop;
          }, 1);
        }

        oldCount = count;
      });
    }
  };
}).directive('mdEditInPlace', function ($compile, $interpolate, $filter) {
  return {
    restrict: 'A',
    require: 'ngModel',
    scope: true,
    link: function link(scope, element, attrs, ngModel) {
      var type;
      var step;
      var form;
      var trigger = 'click';
      var editing = false;
      var initialValue;
      var newValue;

      var template = function template() {
        return ['<form ng-submit="hide()">', '  <md-input-container>', '    <input type="' + type + '" step="' + step + '" ng-model="' + attrs.ngModel + '" ng-blur="hide()"/>', '  </md-input-container>', '</form>'].join("\n");
      };

      attrs.$observe('type', function (t) {
        type = t || 'text';
        ngModel.$render();
      });

      attrs.$observe('step', function (s) {
        step = s || 1;
        ngModel.$render();
      });

      function render() {
        form = angular.element(template());
        initialValue = scope.$eval(attrs.ngModel);
        element.addClass('ng-hide');
        $compile(form)(scope);
        element.after(form);
        form.find('input').focus();
      }

      scope.hide = function hide() {
        if (!form) {
          return;
        }

        form.remove();
        element.removeClass('ng-hide');
        newValue = scope.$eval(attrs.ngModel);

        if (attrs.onUpdate && initialValue !== newValue) {
          scope.$eval(attrs.onUpdate);
        }
      };

      element.on(trigger, function () {
        if (!editing) {
          render();
        }
      });

      ngModel.$render = function () {
        var html = ngModel.$viewValue;

        if (!html || html === '') {
          if (attrs.placeholder) {
            html = $interpolate(attrs.placeholder)(scope);
            element.addClass('placeholder');
          }
        } else {
          element.removeClass('placeholder');

          if (type === 'number' && (step < 1 || step === 'any')) {
            html = $filter('number')(html, 2);
          }
        }

        element.html(html);
      };
    }
  };
}).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.scoresheet', {
    url: '/tabulations/scoresheet/:event/:adjudicator',
    template: require('./tpl.html'),
    controller: TabulationsScoresheetController,
    controllerAs: 'ctrl',
    resolve: {
      event_id: function event_id($stateParams) {
        return $stateParams.event;
      },
      adjudicator_id: function adjudicator_id($stateParams) {
        return $stateParams.adjudicator;
      }
    },
    ncyBreadcrumb: {
      label: 'Scoresheet: {{ ctrl.adjudicator.fname }} {{ ctrl.adjudicator.lname }}',
      parent: 'feiseanna.one.admin.tabulations'
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/tabulations/scoresheet/index.js
// module id = 583
// module chunks = 0